import { render } from "./_4.vue?vue&type=template&id=f420ac20"
import script from "./_4.vue?vue&type=script&lang=js"
export * from "./_4.vue?vue&type=script&lang=js"

import "./_4.vue?vue&type=style&index=0&id=f420ac20&lang=css"

import exportComponent from "/Users/marianne/DevProjects/Marinka backup 29-08-2025/full website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__